module.exports = __webpack_public_path__ + "img/3.958d4e00.png";